import { Search, ShoppingCart } from '@mui/icons-material'
import React from 'react'
import { Link } from 'react-router-dom'
import { useStateValue } from '../StateProvider'
import { useAuth0 } from "@auth0/auth0-react";
import './Navbar.css'
function Navber() {
  const { loginWithRedirect,logout ,isAuthenticated,user } = useAuth0();
  const [{cart}]=useStateValue();
  return (
    <div className='navbar'>
      <Link to='/' className="header_link">
        <img className='navbar_logo' src="https://static-assets-web.flixcart.com/fk-p-linchpin-web/fk-cp-zion/img/flipkart-plus_8d85f4.png" alt="" />
      </Link>
      <div className="navbar_search">
        <input type="text"
        placeholder='Search for products,brands and more'
          className='navbar_searchInput' />
        <Search className='navbar_searchIcon'/>
      </div>
      
      <div className="navber_right">
        {isAuthenticated && (
      <div>
        
        <h5 style={{color:'white',fontSize:'14px'}}>{user.name}</h5>
        
      </div>
    )}
        {isAuthenticated? 
        <div  className="navbar_login">
        <button className='navbar_button' onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
      Log Out
    </button>
    </div>:<div  className="navbar_login">
            <button className='navbar_button' onClick={() => loginWithRedirect()}>Log In</button>
            </div>}
            
       
       
        <Link to='/seller' className="header_link">
            <div className="navbar_seller">
                <h3>Become a Seller</h3>
            </div>
        </Link>
      </div>
      <Link to='/cart' className="header_link">
        <div className="navbar_cart">
            <ShoppingCart/>
            <span className='navbar_cart_num'>{0}</span>
            <span>Cart</span>
        </div>
      </Link>
    </div>
  )
}

export default Navber
